import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  //Desktop view menu
  public state = "open";
  //Mobile view menu
  public menuState = new BehaviorSubject(false)
  isVisibleSidebar = new BehaviorSubject(false);
  notificationData: any = new BehaviorSubject(undefined);
  reloadProfile = new BehaviorSubject(false);
  constructor() { }

  public changeState(): void {
    (this.state == "closed") ? this.state = "open" : this.state = "closed";
  }

  public changeMobileMenuState(isVisible: boolean): void {
    this.menuState.next(isVisible)
  }

  public setIsVisibleSidebar(isVisible: boolean) {
    this.isVisibleSidebar.next(isVisible);
  }

  public onClickNotification(notificationData: any) {
    this.notificationData.next(notificationData);
  }

  public onReloadProfileClick(data: boolean) {
    this.reloadProfile.next(data);
  }
}
